import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Schema } from 'prosemirror-model';
import { getBasicSchema } from './Common/schemaBasic';
import { addListNodes } from 'prosemirror-schema-list';
import layout from './Layout';
import { floatingToolbarPlugin } from './FloatingToolbar';
import table from './Table';
import image from './Image';
import placeholder from './Placeholder';
import mention from './Mention';
import link from './Link';
import media from './Media';
import embedCard from './EmbedCard';
import * as commonMarks from './Common/marks';
import todos from './Todos';

// Plugins should be initialized in the order from atoms to containers, to handle events first at atoms
const atoms = [image, placeholder, mention, media, link, embedCard, todos];
const containers = [table, layout];
const allPlugins = [...atoms, ...containers];
const formatPluginOption = (plugin, pluginOption, editorId, events, editorProps) => {
  const {
    hasInlineStyles,
    renderAsHtml,
    allowUploadDataUrl,
    embedPatterns
  } = editorProps;
  return _objectSpread(_objectSpread(_objectSpread({}, plugin.defaultOptions || {}), pluginOption || {}), {}, {
    editorId,
    events,
    hasInlineStyles,
    renderAsHtml,
    allowUploadDataUrl,
    embedPatterns
  });
};
export const processPlugins = function () {
  let activePlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let pluginOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let editorId = arguments.length > 2 ? arguments[2] : undefined;
  let events = arguments.length > 3 ? arguments[3] : undefined;
  let marks = arguments.length > 4 ? arguments[4] : undefined;
  let editorProps = arguments.length > 5 ? arguments[5] : undefined;
  const {
    hasInlineStyles
  } = editorProps;
  const allMarks = {};
  const basicSchema = getBasicSchema({
    hasInlineStyles
  });
  if (marks && marks.length) {
    marks.forEach(mark => {
      allMarks[mark] = commonMarks[mark];
    });
  }
  const finalConfig = allPlugins.reduce((config, plugin) => {
    const newConfig = _objectSpread({}, config);
    if (activePlugins.includes(plugin.name)) {
      const currentOptions = pluginOptions[plugin.name];
      const options = Array.isArray(currentOptions) ? currentOptions.map(option => formatPluginOption(plugin, option, editorId, events, editorProps)) : formatPluginOption(plugin, currentOptions, editorId, events, editorProps);
      const info = plugin.configure(options, activePlugins);
      if (info.plugins) {
        newConfig.plugins.push(...info.plugins);
      }
      if (info.plugin) {
        newConfig.plugins.push(info.plugin);
      }
      if (info.nodes) {
        newConfig.nodes = newConfig.nodes.append(info.nodes);
      }
      if (info.marks) {
        newConfig.marks = newConfig.marks.append(info.marks);
      }
      if (info.floatingToolbars) {
        info.floatingToolbars.forEach(_ref => {
          let {
            pluginKey,
            info: pluginInfo
          } = _ref;
          newConfig.plugins.push(floatingToolbarPlugin(pluginKey, pluginInfo));
        });
      }
      if (info.menuItems) {
        newConfig.menuItems.push(...info.menuItems);
      }
    }
    return newConfig;
  }, {
    nodes: basicSchema.spec.nodes,
    marks: basicSchema.spec.marks.append(allMarks),
    plugins: [],
    menuItems: []
  });
  const schema = new Schema({
    marks: finalConfig.marks,
    nodes: activePlugins.includes('list') ? addListNodes(finalConfig.nodes, 'paragraph block*', 'block') : finalConfig.nodes
  });
  return _objectSpread({
    schema
  }, finalConfig);
};